export default "__VITE_ASSET__ChkOz1kz__"